import { render, staticRenderFns } from "./treasureList.vue?vue&type=template&id=2b96eef0&scoped=true&"
import script from "./treasureList.vue?vue&type=script&lang=js&"
export * from "./treasureList.vue?vue&type=script&lang=js&"
import style0 from "./treasureList.vue?vue&type=style&index=0&id=2b96eef0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b96eef0",
  null
  
)

export default component.exports